import type React from 'react'

const IconPlus: React.FC = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 2.50014C7 2.22399 6.77614 2.00014 6.5 2.00014H5.5C5.22386 2.00014 5 2.224 5 2.50014V5.00014H2.5C2.22386 5.00014 2 5.22399 2 5.50014V6.50014C2 6.77628 2.22386 7.00014 2.5 7.00014H5V9.50014C5 9.77628 5.22386 10.0001 5.5 10.0001H6.5C6.77614 10.0001 7 9.77628 7 9.50014V7.00014H9.5C9.77614 7.00014 10 6.77628 10 6.50014V5.50014C10 5.22399 9.77614 5.00014 9.5 5.00014H7V2.50014Z"
      fill="currentColor"
    />
  </svg>
)

export default IconPlus
